import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { EducationRoutingModule } from './education-routing.module';
import { EducationsByEducationTypeComponent } from './educations-by-education-type/educations-by-education-type.component';
import { EducationService } from './education.service';
import { SharedModule } from '../shared/shared.module';
import { MaterialModule } from '../shared/material/material.module';
import { EducationDescriptionComponent } from './education-description/education-description.component';
import { EducationsByEducationTypeAndOrganisationComponent } from './educations-by-education-type-and-organisation/educations-by-education-type-and-organisation.component';
import { EducationTypesByOrganisationComponent } from './education-types-by-organisation/education-types-by-organisation.component';



@NgModule({
  declarations: [
    EducationsByEducationTypeComponent,
    EducationDescriptionComponent,
    EducationsByEducationTypeAndOrganisationComponent,
    EducationTypesByOrganisationComponent
  ],
  providers: [
    EducationService
  ],
  imports: [
    CommonModule,
    SharedModule,
    MaterialModule,
    EducationRoutingModule
  ], 
  exports: [
    EducationsByEducationTypeComponent,
    EducationsByEducationTypeAndOrganisationComponent,
    EducationsByEducationTypeAndOrganisationComponent,
    EducationTypesByOrganisationComponent
  ]
})
export class EducationModule { }

export { EducationsByEducationTypeAndOrganisationComponent };
//export { EducationsByEducationTypeAndOrganisationComponent };

